// extracted by css-extract-rspack-plugin
export default {"body":"PxGly"};